import { CatalogConfig } from '@setvi/shared/interfaces';
import { CompanySettingsTypeID } from '@setvi/shared/services/react-query/query/user/types';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

enum PathOverrides {
  CVET_RFQ = 'rfq-digital-showroom'
}

export const useCatalogConfig = () => {
  const { pathname } = useLocation();
  const { companyData } = useAppContext();
  const config: CatalogConfig =
    companyData.Settings[CompanySettingsTypeID.CatalogConfig]?.Value;

  const invalidConfiguration = Object.keys(config || {})?.length === 0;
  const pathOverrideValues = Object.values(PathOverrides);
  const overrides = useMemo(
    () => pathOverrideValues.some(value => pathname?.includes(value)),
    [pathname, pathOverrideValues]
  );

  return {
    configuration: {
      ...config,
      filters: {
        ...config?.filters,
        customer: {
          ...config?.filters?.customer,
          show: overrides ? false : config?.filters?.customer?.show
        }
      }
    },
    invalidConfiguration
  };
};
